var SendMessage=(Id,Name,Phone)=>axios._get(`/api/User/SendMessage?LaboratoryNo=${Id}&Name=${Name}&Phone=${Phone}`);//发送验证码

var Login=(LaboratoryNo,Name,Phone,verify)=>axios._get(`/api/User/LoginByUserPhoneAndLaboratoryNo?LaboratoryNo=${LaboratoryNo}&Name=${Name}&Phone=${Phone}&verify=${verify}`);//登录
var SendMessagesVoice=(Id,Name,Phone)=>axios.get(`/api/User/SendAudioMessage?Id=${Id}&Name=${Name}&Phone=${Phone}`);//語音發送驗證碼

var LoginsImg=(Id,Name,Phone,verify)=>axios._get(`/api/User/LoginUrlByUserPhoneAndLaboratoryNoImg?Id=${Id}&Name=${Name}&Phone=${Phone}&verify=${verify}`);

var Logins=(Id,Name,Phone,verify)=>axios._get(`/api/User/LoginUrlByUserPhoneAndLaboratoryNo?Id=${Id}&Name=${Name}&Phone=${Phone}&verify=${verify}`);
var ConsultionInfo=( Name,Phone,  Email,  Subject,  LeavingMessage)=>axios._get(`/api/Consultation/ConsultionInfo?Name=${Name}&Phone=${Phone}&Email=${Email}&Subject=${Subject}&LeavingMessage=${LeavingMessage}`);
var GetPagNewsAll=()=>axios._get(`/api/News/GetPagNewsAll`);//获取报告消息
var GetNews=(pageIndex, pageSize)=>axios._get(`/api/News/GetAvailableNewsPagination`, {pageIndex, pageSize});//获取报告消息
var GetNotices=(pageIndex, pageSize)=>axios._get(`/api/Notice/GetAvailableNoticePagination`, {pageIndex, pageSize});//获取报告消息
var GetNotice=(id)=>axios._get(`/api/Notice/Get`, {id});//获取报告消息

var GetNewNewly = ()=> axios._get('api/News/GetNewNewly');//获取公告

var LoginAliYun=(params)=>axios._post(`/api/User/LoginByUserPhoneAndLaboratoryNoUseAliyun`,params);//阿里云无痕验证登录
export{
    SendMessage,
    Login,
    SendMessagesVoice,
    Logins,
    ConsultionInfo,
    GetPagNewsAll,
    LoginsImg,
    GetNewNewly,
    LoginAliYun,
  GetNews,
  GetNotices,
  GetNotice
}



// WEBPACK FOOTER //
// ./src/service/searchreport.js